import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantRestrictionListRequest {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  merchantId?: number;
}

async function getMerchantRestrictionList(data: IMerchantRestrictionListRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/MerchantRestriction/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantRestrictionList() {
  return useMutation<any, Error, IMerchantRestrictionListRequest>((variables) =>
    getMerchantRestrictionList(variables)
  );
}
